import { Edit } from "react-admin";
import * as React from "react";
import { OurContactCreateForm } from "./OurContactCreate";

export const OurContactEdit = () => (
  <Edit>
    <OurContactCreateForm />
  </Edit>
);
